import { render, staticRenderFns } from "./ReporteEstatusInspecciones.vue?vue&type=template&id=4bf64a2e&scoped=true&"
import script from "./ReporteEstatusInspecciones.vue?vue&type=script&lang=js&"
export * from "./ReporteEstatusInspecciones.vue?vue&type=script&lang=js&"
import style0 from "./ReporteEstatusInspecciones.vue?vue&type=style&index=0&id=4bf64a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf64a2e",
  null
  
)

export default component.exports